/**
 * Standalone service products that admins can redeem without an active subscription.
 * Mirrors priorityone_backend/utils/adminManualServiceProducts.js
 */

const INSIDE_OUT_WASH_REGEX = /Inside.*Out.*Wash/i;
const SEDAN_REGEX = /Inside.*Out.*Wash.*(Sedan|Hatch)/i;
const WAGON_REGEX = /Inside.*Out.*Wash.*(SUV|Wagon)/i;
const FOURWD_REGEX = /Inside.*Out.*Wash.*(4WD|7Seater|7 Seater)/i;

function isAddOnInsideOutWash(product) {
  if (!product || !product.name) return false;
  if (!product.isAddOnOnly) return false;
  if (!INSIDE_OUT_WASH_REGEX.test(product.name)) return false;
  if (
    SEDAN_REGEX.test(product.name) ||
    WAGON_REGEX.test(product.name) ||
    FOURWD_REGEX.test(product.name)
  ) {
    return false;
  }
  return true;
}

export const ADMIN_MANUAL_SERVICE_GROUP_LABEL = "Add-On Products";

export function isAdminManualServiceProduct(product) {
  if (!product || !product.name) return false;

  const name = product.name;

  if (isAddOnInsideOutWash(product)) return true;
  if (/headlight.*restor/i.test(name)) return true;
  if (/leather.*treatment/i.test(name)) return true;
  if (/wheel.*detail/i.test(name)) return true;

  return false;
}

export function productRequiresVehicleVariant(product) {
  if (!product) return false;
  return (
    isAdminManualServiceProduct(product) ||
    !!product.isAddOnOnly ||
    product.supportsVehicleVariantPricing === true
  );
}
